import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Cookies = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen text-white" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Header */}
      <nav className="px-6 lg:px-12 py-6 border-b border-white/10">
        <div className="flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2">
            <img src="/revocut-logo.png" alt="RevoCut" className="w-10 h-10" />
            <span className="text-xl font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>REVOCUT</span>
          </button>
          <button 
            onClick={() => navigate(-1)}
            className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </button>
        </div>
      </nav>

      {/* Content */}
      <main className="px-6 lg:px-12 py-12 max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Cookie-Richtlinie
        </h1>

        <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
          <p className="text-lg">
            Stand: März 2026
          </p>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">1. Was sind Cookies?</h2>
            <p>
              Cookies sind kleine Textdateien, die auf Ihrem Computer oder mobilen Gerät gespeichert werden, 
              wenn Sie unsere Website besuchen. Sie ermöglichen es uns, Ihre Präferenzen zu speichern und 
              Ihr Nutzererlebnis zu verbessern.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">2. Welche Cookies verwenden wir?</h2>
            
            <h3 className="text-lg font-semibold text-white">2.1 Notwendige Cookies</h3>
            <p>
              Diese Cookies sind für den Betrieb unserer Website unbedingt erforderlich. Dazu gehören 
              beispielsweise Cookies, die es Ihnen ermöglichen, sich in sichere Bereiche unserer Website 
              einzuloggen.
            </p>

            <h3 className="text-lg font-semibold text-white">2.2 Funktionale Cookies</h3>
            <p>
              Diese Cookies ermöglichen es uns, Ihre Einstellungen und Präferenzen zu speichern, 
              z.B. Ihre Spracheinstellungen oder Login-Daten.
            </p>

            <h3 className="text-lg font-semibold text-white">2.3 Analyse-Cookies</h3>
            <p>
              Wir verwenden Analyse-Cookies, um zu verstehen, wie Besucher mit unserer Website interagieren. 
              Diese Informationen helfen uns, unsere Website zu verbessern.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">3. Cookies von Drittanbietern</h2>
            <p>
              Auf unserer Website können auch Cookies von Drittanbietern gesetzt werden, z.B. von 
              Zahlungsdienstleistern (Stripe) oder Analyse-Tools. Diese Drittanbieter haben ihre 
              eigenen Datenschutzrichtlinien.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">4. Ihre Cookie-Einstellungen</h2>
            <p>
              Sie können Ihre Browser-Einstellungen so anpassen, dass Cookies blockiert oder gelöscht werden. 
              Beachten Sie jedoch, dass einige Funktionen unserer Website möglicherweise nicht mehr 
              ordnungsgemäß funktionieren, wenn Sie Cookies deaktivieren.
            </p>
            <p>
              Die meisten Browser bieten folgende Optionen:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Alle Cookies akzeptieren</li>
              <li>Benachrichtigung bei Cookie-Setzung</li>
              <li>Alle Cookies ablehnen</li>
              <li>Bereits gespeicherte Cookies löschen</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">5. Kontakt</h2>
            <p>
              Bei Fragen zu unserer Cookie-Richtlinie kontaktieren Sie uns unter:
            </p>
            <p>
              E-Mail: info@revocut-media.de
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Cookies;
